import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {ApiVisa} from '../../shared/api-visa.model';

@Injectable({
  providedIn: 'root'
})
export class ShopeeGetPrintableService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'shopee/get-printable-documents';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'shopee/get-printable-documents';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'shopee/get-printable-documents';
    this.httpClient = http;
  }

  getPrintable(branchGuid: string, dtoObject: any, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '?' + 'branch_guid=' + branchGuid;
    return this.httpClient.post(url, dtoObject, this.getHttpHeader(apiVisa));
  }

  getPrintablePromise(branchGuid: string, dtoObject: any, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '?' + 'branch_guid=' + branchGuid;
    // return this.httpClient.post(url, dtoObject, this.getHttpHeader(apiVisa)).toPromise();
    return this.httpClient.post<Blob>(
      url,
      dtoObject,
      this.getHttpHeaderBlob(apiVisa)
    ).toPromise();
  }
}
